export const APP_PATH = '/ehub';
export const HOST_API = process.env.REACT_APP_SERVER_API;
export const HOME_URL = process.env.REACT_APP_HOME_URL || '';
export const CUSTOMER_SERVICE_URL =
  process.env.REACT_APP_CUSTOMER_SERVICE_URL || '';
